import React from 'react';

interface IUserIconProps {
	firstName: string;
	lastName: string;
}

export const UserIcon = ({ firstName, lastName }: IUserIconProps): JSX.Element => {

	return (
		<div className="d-flex align-items-center justify-content-center fs-6 bg-light-danger text-danger fw-bolder w-35px h-35px rounded-circle">
			<span>{firstName?.[0]}</span>
			<span>{lastName?.[0]}</span>
		</div>
	);
};
